import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BrokerService } from './core/services/broker.service';
import { SesionService } from './core/services/sesion.service';
import { UtilitiesService } from './core/services/utilities.service';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { DataLayersService } from './core/services/data-layers.service';
import { LoadService } from './core/services/load.service';
import { RuntimeConfigService } from './core/config/services/runtime-config.service';
//datadog
import { datadogRum } from '@datadog/browser-rum'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {
  env = environment;
  title = 'buscacredito';
  txt: any;
  public innerWidth: any;
  public isMobile: any = false;
  public isTablet: any = false;
  public isMedium: any = false;
  public isDesktop: any = false;
  public showEducationBtn: boolean = true;
  private readonly runtimeConfig: RuntimeConfigService = inject(RuntimeConfigService);
  public readonly layout = this.runtimeConfig.layout;
  public readonly features = this.runtimeConfig.features;
  public readonly application = this.runtimeConfig.application;

  constructor(private broker: BrokerService, public sesion: SesionService, public utilities: UtilitiesService, public router: Router, public dataLayer: DataLayersService, private activateRoute: ActivatedRoute) {

    if (environment.gtmPruebas) {
      const script = document.createElement('script');
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PVMDQRP');`;
      document.head.appendChild(script);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PVMDQRP"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.appendChild(noscript);
    } else {

      const script = document.createElement('script');
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WJGTVCC');`;
      document.head.appendChild(script);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WJGTVCC"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.appendChild(noscript);

      ///// Hotjar Tracking Code for https://www.midatacredito.com 
      const scriptHotjar = document.createElement('script');
      scriptHotjar.innerHTML = `(function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:1601850,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
      document.head.appendChild(scriptHotjar);
    }

    this.initOptinMonster();
  }

  /**
   * Inyecta el SDK de OptinMonster solo si el ambiente lo habilita
   * (environment.optinMonster.enabled). Evita el error 1006 (dominio no
   * registrado en la cuenta) en ambientes previos como local, dev, qa y demo.
   */
  private initOptinMonster(): void {
    const { enabled, userId, accountId } = environment.optinMonster;
    if (!enabled || document.getElementById('optinmonster-sdk')) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'optinmonster-sdk';
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://a.omappapi.com/app/js/api.min.js';
    script.dataset['user'] = String(userId);
    script.dataset['account'] = String(accountId);
    document.head.appendChild(script);
  }

  ngOnInit() {
    const isConectaBancolombia = window.location.pathname.includes('/conecta/bancolombia');
    const code = new URLSearchParams(window.location.search).get('code');
    if (isConectaBancolombia && code) {
      const isSigningFlow = localStorage.getItem('signing_flow_active') === 'true';
      localStorage.removeItem('signing_flow_active');
      localStorage.setItem(isSigningFlow ? 'signing_auth_code' : 'fua_auth_code', code);
      if (window.opener) {
        window.close();
      }
      return;
    }

    localStorage.removeItem('omVisitsFirst');
    localStorage.removeItem('omVisits');
    this.broker.contenido_interface().subscribe((response: any) => {
      this.txt = response;
      this.sesion.datos = response;
    },
      (error) => {
      }
    );
    let url;
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        url = val.url;
        if (url.includes('blog') || url.includes('financial-info')) {
          this.showEducationBtn = false;
        } else {
          this.showEducationBtn = true;
        }
      }
    });
    this.activateRoute.queryParams.subscribe(params => {
      if (params['webview'] != undefined) {
        localStorage.setItem('webview', 'webview');
      }
      if (params['webview-ios'] != undefined) {
        localStorage.setItem('webview', 'webview-ios');
      }
    });
  }

  goBlog() {
    this.dataLayer.dl_eventoGA4_general('clic_topo');
    this.router.navigate(['/blog']);
  }


  setRum() {
    this.broker.loadParameters('INIT').subscribe(
      {
        next: (data: any) => {
          this.sesion.configurationPad = 0;
          if (data.parameters.ConfigurationPad != undefined) {
            this.sesion.configurationPad = data.parameters.ConfigurationPad;
          }
          this.sesion.flagCampaign = data.parameters.flagCampaign;
          let ddRum = data.parameters.flagDatadog != undefined ? data.parameters.flagDatadog : environment.datadog;
          if (ddRum) {
            let client = this.sesion.getVariables(data.parameters.DdAppId, data.parameters.validateOTPU.slice(4, -8));
            let token = this.sesion.getVariables(data.parameters.DdCT, data.parameters.validateOTPU.slice(4, -8));
            datadogRum.init({
              applicationId: client,
              clientToken: token,
              // `site` refers to the Datadog site parameter of your organization
              // see https://docs.datadoghq.com/getting_started/site/
              site: 'datadoghq.com',
              service: `${environment.envName}-bc`,
              env: environment.envName,
              // Specify a version number to identify the deployed version of your application in Datadog
              // version: '1.0.0',
              sessionSampleRate: data.parameters.DdSample,
              sessionReplaySampleRate: data.parameters.DdReplaySample,
              defaultPrivacyLevel: 'mask-user-input',
              trackSessionAcrossSubdomains: true,
              useSecureSessionCookie: true,
              storeContextsAcrossPages: true,

              trackResources: true,			// Enable Resource tracking
              trackUserInteractions: true,	// Enable Action tracking
              trackLongTasks: true,			// Enable Long Tasks tracking
            });
          }
        },
        error: (error: any) => {
        }
      })
  }
}
